export class FinancialConstant {
  static readonly payoutMin: number = 1000;
  static readonly payoutMax: number = 50000;
  static readonly payoutMinText: string = '1,000';
  static readonly payoutMaxText: string = '50,000';
}